
import { emailValidation } from '@eneco/common/validation/emailRegex';
import passwordRegex from '@eneco/common/validation/passwordRegex';
import * as yup from 'yup';

export const registerPersonSchema = yup.object({
  emailAddress: emailValidation({ emailMessage: 'emailInvalid', requiredMessage: 'emailRequired' }),
  password: yup.string().required('passwordRequired').matches(passwordRegex, 'passwordInvalid'),
});
